export enum SoaItemType {
  PortIn,
  PortOut,
  SearchAndProvision,
  Disconnect,
  Modify,
  Audit,
  DisasterRecovery
}
